module.exports = __webpack_public_path__ + "static/media/focus.ad723b75.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200S冷藏车/focus.png
// module id = 721
// module chunks = 0